import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { Timezone } from '~/types/models';

export const timezonesApiPath = '/api/v3/timezones';

export async function getTimezones() {
  const res = await axios.get<Timezone[]>(timezonesApiPath);
  return res.data;
}

export function useTimezones(
  options?: UseQueryOptions<Timezone[], AxiosError>
) {
  return useQuery<Timezone[], AxiosError>('timezones', getTimezones, options);
}
